module.exports = __webpack_public_path__ + "static/accepted_check-c940b94818a90fccd998995e2eb6b870.gif";